const styles = () => ({
  heading: {
    margin: '0 0 20px',
    fontSize: '18px',
    lineHeight: '22px'
  }
})

export default styles
